import { t } from "../../Utils/translate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchWaivedOffAppointments } from "../../modules/WaiverOff/appointmentsThunk";
import "./WaivedOffAppointments.css";
import moment from "moment";

function WaivedOffAppointments() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  const [expandedRows, setExpandedRows] = useState([]);

  const waivedOffData = useSelector(state => state.appointments.fetchWaivedSuccess?.data || {});
  const waivedOffAppointments = waivedOffData.waivedOffAppointments || [];
  const fetchStatus = useSelector(state => {
    if (state.appointments.fetchWaivedLoading) return "loading";
    if (state.appointments.fetchWaivedError) return "failed";
    if (state.appointments.fetchWaivedSuccess) return "succeeded";
    return "idle";
  });
  const error = useSelector(state => state.appointments.fetchWaivedError);

  useEffect(() => {
    dispatch(fetchWaivedOffAppointments({ page: currentPage, limit: itemsPerPage }));
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (fetchStatus === "succeeded") {
      setTotalPages(waivedOffData.totalPages || 0);
    }
  }, [fetchStatus, waivedOffData]);

  const toggleReason = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter(rowId => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) pages.push(1, 2, { type: "ellipsis" }, totalPages);
      else if (currentPage >= totalPages - 1) pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      else pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
    }
    return pages;
  };

  const handleClick = (pageNumber) => setCurrentPage(pageNumber);
  const handlePrevNext = (direction) => {
    if (direction === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
    else if (direction === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (fetchStatus === "loading") return <div>{t("loadingWaivedAppointments")}</div>;
  if (fetchStatus === "failed") return <div className="no-records">{t("errorLoadingData")}: {error}</div>;
  if (!waivedOffAppointments.length) return <div className="no-records">{t("noWaivedAppointments")}</div>;

  return (
    <div className="waived-table-wrapper">

      <h2 className="waived-title">{t("waivedOffAppointments")}</h2>
      <h2 className="total-fees-title">
        {t("totalWaivedFees")}:{" "}
        <span className="currency-Symbol">
            {waivedOffData?.totalWaivedAmount?.currencySymbol || ''}
        </span>
        {" "}
        {waivedOffData?.totalWaivedAmount?.totalAmount !== undefined 
          ? waivedOffData.totalWaivedAmount.totalAmount.toLocaleString() 
          : '0'}
      </h2>

      <table className="waived-table">
        <thead>
          <tr>
            <th>{t("patientName")}</th>
            <th>{t("phoneNumber")}</th>
            <th>{t("doctorName")}</th>
            <th>{t("doctorId")}</th>
            <th>{t("appointmentDate")}</th>
            <th>{t("consultationFee")}</th>
            <th>{t("waiveOffBy")}</th>
            <th>{t("waiveOffDate")}</th>
            <th>{t("waiveOffReason")}</th>
          </tr>
        </thead>
        <tbody>
          {waivedOffAppointments.map((item) => (
            <tr key={item._id}>
              <td>{item.patient.fullName}</td>
              <td>
                {item.patient.countryCode.includes("+") ? item.patient.countryCode : "+" + item.patient.countryCode}{" "}
                {item.patient.phoneNumber}
              </td>
              <td>{item.doctor.name}</td>
              <td>{item.doctor.employeeID}</td>
              <td>{`${moment(item.appointmentDate).format("DD/MM/YYYY HH:mm")}`}</td>
              <td>{item.currencySymbol} {item.consultationFee}</td>
              <td>{item?.waiveOffApproverName && item.waiveOffApproverName  + " (" + item?.waiveOffApproverEmail + " )"}</td>
              <td>{item?.waiveOffApprovalDate && `${moment(item.waiveOffApprovalDate).format("DD/MM/YYYY HH:mm")}`}</td>
              <td
                onClick={() => toggleReason(item._id)}
                style={{ cursor: "pointer" }}
                title="Click to expand/collapse"
              >
                {expandedRows.includes(item._id)
                  ? item.waiveOffReason
                  : item.waiveOffReason.length > 40
                    ? item.waiveOffReason.slice(0, 40) + "..."
                    : item.waiveOffReason
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {totalPages > 0 && (
        <div className="pagination-list">
          <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1}>{"<"}</button>
          {renderPagination().map((page, index) =>
            typeof page === "number" ? (
              <button
                key={index}
                onClick={() => handleClick(page)}
                disabled={page === currentPage}
                className={page === currentPage ? "active" : ""}
              >
                {page}
              </button>
            ) : (
              <button key={index} disabled className="ellipse">...</button>
            )
          )}
          <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages}>{">"}</button>
        </div>
      )}

    </div>
  );
}

export default WaivedOffAppointments;
